export class CalypsoEvent {
    constructor(
        public calling: boolean,
        public originNumber: string,
        public operator: string,
        public cause: string,
        public causeDescription: string,
        public contactId: string,
        public terminal: string,
        public connection: string,
        public message: string,
        public callingType = ""
    ) {

    }
}